<script setup>
import { useTabable } from '/app/composables/tabable';
import { useHideable } from '/app/composables/hideable';
import { inject, onMounted, onBeforeUnmount, computed } from 'vue';

const props = defineProps({
    id: String,
    title: { type: String, required: true },
    complete: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    showLeft: { type: Boolean, default: false },
    showRight: { type: Boolean, default: false },
    activator: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
});

const emit = defineEmits(['open', 'close']);
const stepper = inject('stepper');

const { slug, isOpen } = useTabable(props, emit, stepper);
const { hidden } = useHideable(slug.value, { isOpen });

const step = computed(() => ({
    slug,
    isOpen,
    hidden,
    title: computed(() => props.title),
    complete: computed(() => props.complete),
    disabled: computed(() => props.disabled),
    showLeft: computed(() => props.showLeft),
    showRight: computed(() => props.showRight),
    activator: computed(() => props.activator),
    hideActions: computed(() => props.hideActions),
}));

onMounted(() => {
    stepper.steps.push(step.value);
});

onBeforeUnmount(() => {
    const index = stepper.steps.indexOf(step.value);
    if (index > -1) stepper.steps.splice(index, 1);
});
</script>

<template>
    <div v-show="! hidden && isOpen" :key="slug" class="w-full step-content" >
        <slot></slot>
    </div>
</template>
